//oppo隐私合规

PrivacyUtil = xClass("PrivacyUtil")
var privacy_config = null
const STORAGE_KEY = "_local_privacy_agreed_";

/**
 * 是否需要展示隐私协议
 */
PrivacyUtil.isOpen = function () {
        // return true;
        let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
        cc.log("[PrivacyUtil] PrivacyUtil isOpen pf ",pf);
        if (pf == "oppo_quickgame" || pf == "honor_quickgame"  || pf == "mi_quickgame"
            || pf == "qq_lightgame" || pf == "douyin_game" || pf == "kuaishou_game"
            || pf == "wanba_ts" || pf == XcloverPlatform.huawei) {
            return true;
        }
        return false;
}


/**
 * 保存用户是否同意隐私协议
 * choose: 0：不同意 1：同意       
 */
PrivacyUtil.savePrivacyStorage = function(choose) {
    cc.sys.localStorage.setItem(STORAGE_KEY, choose);
}

/**
 * 读取用户是否同意隐私协议
 * 0：不同意 1：同意       
 */
PrivacyUtil.getPrivacyStorage = function(){
    return Number(cc.sys.localStorage.getItem(STORAGE_KEY));
}

/**
 * 强弹隐私文本summary面板
 */
PrivacyUtil.openMiniPrivacyPanel = function (agreeCb, disagreeCb) {
    var panel = require("clover/panel/component/privacyPanels/sumPrivacyPanel").create(agreeCb, disagreeCb)
    panel.popup()

}


/**
 * 打开隐私文本面板
 * entry: "userAgreement" or "privacyPanel"        
 */
 PrivacyUtil.openPrivacyPanel = function (entry, closeCb,isCheckScene) {
    // var panel = require("clover/panel/component/privacyPanels/PrivacyPanel").create(entry, closeCb)
    cc.log("openPrivacyPanel isCheckScene",isCheckScene)
    if (cc.sys.platform === cc.sys.WECHAT_GAME || getCurrentPlatform() == XcloverPlatform.huawei) {
        if (entry == "privacyPolicy" && window._hwShowWebPrivacy == true){
            // 华为小游戏隐私界面跳转网页
            GameProxy.getInstance().openUrl("https://clover.happyelements.cn/privacy_hw.html")
            if (closeCb) closeCb()
            return
        }
    }
    let PrivacyPanel = require("clover/panel/component/privacyPanels/PrivacyPanel")
    PrivacyPanel.preloadRes(entry, ()=>{
        if (isCheckScene){
            var curScene = cc.Director.getInstance().getRunningScene()
            cc.log("openPrivacyPanel curScene ",curScene.name)
            if (!curScene || curScene.name == "PreloadScene"){
                var panel = PrivacyPanel.create(entry, closeCb)
                panel.popup()
            }else{
                if (closeCb) closeCb()
            }
        }else{
            var panel = PrivacyPanel.create(entry, closeCb)
            panel.popup()
        }

    })

}

/**
 * 加载隐私面板背景资源和文本配置 只在preloadscene调用      
 */
PrivacyUtil.loadRes = function (cb) {
    
    console.log("privacy loadRes")
    Promise.all([
        ResManager.load(["cocos/commonLib.plist"]),
        this.loadConfigInfoPromise()
    ])
    .then((data)=>{
        cc.log("PrivacyUtil loadres successful"); 
        if (cb){
            cb();
        }
    })
    .catch((err)=>{
        console.error("PrivacyUtil.loadRes failed.", err)
    });

}

/**
 * 加载隐私面板文本配置     
 */
PrivacyUtil.loadConfigInfoPromise = function (cb) {
    // loadConfigInfoPromise() {
        console.log("privacy loadConfigInfoPromise")

        return new Promise((resolve, reject)=> {
            CfgManager.load("privacy_config").then(() => {
                privacy_config = CfgManager.get("privacy_config"); //这里改为用到的表名称 
                console.log("privacy_config", privacy_config)
                CfgManager.release("privacy_config");
                resolve(privacy_config);
            }).catch((err) => {
                // console.error("[Seaside]", "load seaside_star_config config failed!", err);
                reject(err);
            });
        })
    // },
    
}

/**
 * 获取隐私面板文本配置     
 */
PrivacyUtil.getPrivacy_config = function() {
    // console.log("privacy_config is or not",privacy_config)
    if (privacy_config){
        return privacy_config;

    }else{
        cc.log("[privacy_config]", "can't get privacy_config in PrivacyUtil.getPrivacy_config ");
       
    }
    
}

module.exports = PrivacyUtil;